import instance from "../config";

const getEmpleados = async (params) => {
  try {
    const response = await instance.get("/api/empleado", { params });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const PostEmpleados = async (idPersona, cargo, salario) => {
  try {
    const response = await instance.post("/api/empleado", {
      idPersona,
      cargo,
      salario,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const PostPersona = async (data) => {
  try {
    const response = await instance.post("/api/persona", data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar un empleado

const EliminarEmpleado = async (idEmpl) => {
  try {
    const response = await instance.delete(`/api/empleado/${idEmpl}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// metodo para editar la persona y el empleado

const EditarEmpleado = async (idEmpl, cargo, salario) => {
  try {
    const response = await instance.put(`/api/empleado/${idEmpl}`, {
      cargo,
      salario,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// metodo para editar la persona
const EditarPersona = async (idP, data) => {
  try {
    const response = await instance.put(`/api/persona/${idP}`, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// metodo para obtener una nomina para un empleado
const obtenerNomina = async (idEmpl, params) => {
  try {
    const response = await instance.get(`/api/empleado/${idEmpl}`, { params });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const PostEmpleadosDetalle = async (
  empleadoId,
  horaEntrada,
  inicioReceso,
  finReceso,
  horaSalida,
  fecha_ingreso,
  adelanto,
  estadoPago,
  vendedor

) => {
  try {
    const response = await instance.post("/api/nomina", {
      empleadoId,
      horaEntrada,
      inicioReceso,
      finReceso,
      horaSalida,
      fecha_ingreso,
      adelanto,
      estadoPago,
      vendedor,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const actualizarNomina = async (id, data) => {
  try {
    const response = await instance.put(`/api/nomina/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const verAbonoEmpleado = async () => {
  try {
    const response = await instance.get(`/api/abonoempleado`);
    return response.data;
  } catch (error) {
    return [];
  }
};
const PostAbonoNomina = async (empleadoId, monto, vendedor) => {
  try {
    const response = await instance.post("/api/abonoempleado", {
      empleadoId,
      monto,
      vendedor,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const actualizarAbono = async (id, monto, vendedor) => {
  try {
    const response = await instance.put(`/api/abonoempleado/${id}`, { monto, vendedor });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar un abono
const EliminarAbono = async (id) => {
  try {
    const response = await instance.delete(`/api/abonoempleado/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para  pagar la nomina
const PostpagoNomina = async (dataNomina) => {
  try {
    const response = await instance.post("/api/pagonomina", { dataNomina });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar un abono
const EliminarRegistroNomina = async (id) => {
  try {
    const response = await instance.delete(`/api/nomina/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar todo los abonos de un empleado
const eliminarAbonos = async (empleadoId) => {
  try {
    const response = await instance.delete(
      `/api/todo/abonoempleado/${empleadoId}`
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para reset adelantos
const resetAdelantosNomina = async (dataNomina) => {
  try {
    const response = await instance.post("/api/resetnomina", { dataNomina });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

//metodo para agregar un adelanto
const postAdelanto = async (data) => {
  try {
    const response = await instance.post(`/api/adelantoempleado`, data);
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Metodo para eliminar un adelanto
const deleteAdelanto = async (id) => {
  try {
    const response = await instance.delete(`/api/adelantoempleado/${id}`);
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// Metodo para actualizar un adelanto
const putAdelanto = async (id, horaEntrega, adelanto, descripcionAdelanto) => {
  try {
    const response = await instance.put(`/api/adelantoempleado/${id}`, {
      monto: adelanto,
      descripcion: descripcionAdelanto,
      horaEntrega,
    });
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

export {
  getEmpleados,
  PostEmpleados,
  PostPersona,
  EliminarEmpleado,
  EditarEmpleado,
  EditarPersona,
  obtenerNomina,
  PostEmpleadosDetalle,
  actualizarNomina,
  verAbonoEmpleado,
  PostAbonoNomina,
  actualizarAbono,
  EliminarAbono,
  PostpagoNomina,
  EliminarRegistroNomina,
  eliminarAbonos,
  resetAdelantosNomina,
  postAdelanto,
  deleteAdelanto,
  putAdelanto,
};
